/**
 * Handle fields validation
 *
 */
//console.log(tgblFields)

const FieldsValidation = ($) => {

  if (!window.Tangible) return
  const tangibleSelect = window.Tangible.Select
  const localized = tgblFields.localized
  const validator_active = typeof $.fn.validate !== 'undefined'
  if (!validator_active) return

  const parent= $( 'tangible-fields' )
  const parent_form= parent.parents('form')

  $(document).ready(function () {
    window.TangibleFieldsValidation.constructor()
  })

  window.TangibleFieldsValidation = {

    // initialize the code
    constructor: function () {
      const $_this =this;
      //let parent = $('.tangible-resource-library-settings')
      if (parent.length) {
        this.checkSettingsRequiredFields(parent,$_this)
      }
    },

    checkSettingsRequiredFields: function (parent,$_this) {

      const submit_button = parent_form.find('input#submit')
      submit_button.on('click',function(e){

        // validate form

        const valid = $_this.validateForm(parent_form,$_this)
        $_this.validationErrorsNumber($_this, parent_form)
      })
    },

    validateForm: function (form, $_this, return_object ){

      // validate forms data

      const validator = form.validate({
        ignore: [],
        //focusCleanup: true,
        focusInvalid: false,
        errorPlacement: function(error, element) {
          error.appendTo( element.parents('.tgbl-field-wrap').find('.tgbl-validation-error') )
        },
        onfocusout: function(element,event) {

          if (element.tagName === "TEXTAREA" || (element.tagName === "INPUT" && element.type !== "password")) {
            element.value = $.trim(element.value);
          }

          $(element).valid()
          const errors = this.numberOfInvalids()
          if (errors) {
            const message = errors == 1  ? localized.missed_field : localized.missed +' '+ errors + ' ' + localized.fields_highlited
            $('div.tgbl-error span').html(message)
            $('div.tgbl-error').show()
          } else {
            $('div.tgbl-error').hide()
          }
          //console.log(errors)
        },
        invalidHandler: function(event, validator) {

          // 'this' refers to the form
          const errors = validator.numberOfInvalids()
          if (errors) {
            const message = errors == 1  ? localized.missed_field : localized.missed +' '+ errors + ' ' + localized.fields_highlited
            $('div.tgbl-error span').html(message)
            $('div.tgbl-error').show()
          } else {
            $('div.tgbl-error').hide()
          }
        }
        /*rules: {},*/
      })

      // return validator object if required
      if(undefined != return_object) return validator

      const valid= form.valid()

      return valid
    },

    validationErrorsNumber: function ( $_this, form ){

      const validator = $_this.validateForm(form,$_this,true)
      const errors = validator.numberOfInvalids()
      if (errors) {
        const message = errors == 1   ? localized.missed_field : localized.missed +' '+ errors + ' ' + localized.fields_highlited
        $('div.tgbl-error span').html(message)
        $('div.tgbl-error').show()
      } else {
        $('div.tgbl-error').hide()
      }
    },
  }
}

export { FieldsValidation }
